<template>
  <div class="schedule schedule-component wd-1200">

    <moduleTitle :large="large" :moduleFlag="moduleFlag" />

    <div class="schedule-container" v-if="moduleInfo.length > 0">
      <div class="schedule-tabs">
        <div class="schedule-tabs-title">
          <i class="schedule-time-icon el-icon-time"></i>
          <span>大会日程总览</span>
        </div>
        <div
          class="schedule-tabs-item"
          :class="{ checked: checkedIndex === index }"
          v-for="(item, index) in moduleInfo"
          @click="handleCheckItem(item, index)"
          :key="item.id">
          <span :class="{ checkedSpan: checkedIndex === index }">
            {{ item.typeName.length > 12 ? item.typeName.slice(0, 12) + '...' : item.typeName }}
          </span>
        </div>
      </div>
      <div class="schedule-image" v-if="checkedItem.pcBackgroundImage">
        <img :src="checkedItem.pcBackgroundImage"/>
      </div>
    </div>
    <div class="more" v-if="isMore">
      <span @click="handleMore">查看更多</span>
    </div>
  </div>
</template>

<script>
  import moduleTitle from '@/components/pc/module-title';

  export default {
    components: { moduleTitle },
    props: {
      moduleInfo: {
        type: Array,
        default: () => []
      },
      moduleFlag: {
        type: String,
        default: '',
      },
      isMore: {
        type: Boolean,
        default: true
      },
      large: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        checkedIndex: '',
        checkedItem: {},
      }
    },
    methods: {
      handleCheckItem(item, index) {
        this.checkedItem = item
        this.checkedIndex = index
      },
      handleMore() {
        // this.$router.push({ name: 'schedule' })
        this.$router.push({ 
          name: 'schedule',
          params: {
            moduleIndex: this.moduleFlag.split('_')[1]
          }
        })
      }
    },
    created() {
      console.log('this.moduleInfo', this.moduleInfo)
    },
    mounted() {
      if (this.moduleInfo.length > 0) {
        const fistData = this.moduleInfo[0]
        this.handleCheckItem(fistData, 0)
      }
    }
  }
</script>

<style scoped lang="scss">
  .schedule {
    overflow: hidden;
    margin-bottom: 30px;

    .schedule-container {
      overflow: hidden;

      .schedule-tabs {
        float: left;
        overflow-y: auto;
        width: 240px;
        margin: 0 30px 0 8px;
        min-height: 100px;
        color: #333;
        background: #fff;
        box-shadow: 0 0 12px 0 rgba(21,159,232,0.10);

        .schedule-tabs-title {
          height: 54px;
          line-height: 54px;
          padding-left: 40px;
          position: relative;
        }

        .schedule-tabs-item {
          height: 54px;
          line-height: 54px;
          cursor: pointer;
          overflow: hidden;

          span {
            padding: 6px 0 6px 40px;
          }

          .checkedSpan {
            padding-left: 32px;
            border-left: 8px solid var(--themeColor);
          }
        }

        .checked {
          background-color: var(--themeColor);
          color: #fff;
        }
      }

      .schedule-image {
        width: 922px;
        float: left;

        img {
          width: 100%;
          height: 100%;
          display: inline-block;
        }
      }
    }

    .schedule-time-icon {
      display: inline-block;
      position: absolute;
      top: 18px;
      left: 18px;
      color: var(--themeColor);
    }
  }
</style>
